/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { LabelFromJSON, LabelToJSON } from './Label';
export function GetLabelsResponseDataFromJSON(json) {
    return GetLabelsResponseDataFromJSONTyped(json, false);
}
export function GetLabelsResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        labels: !exists(json, 'labels') ? undefined : json['labels'].map(LabelFromJSON)
    };
}
export function GetLabelsResponseDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        labels: value.labels === undefined ? undefined : value.labels.map(LabelToJSON)
    };
}
